import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "../../pages/LoginPage";
import ResetPasswordPage from "../../pages/ResetPasswordPage";
import CaForm25Page from "../../pages/ca/CaForm25Page";
import CaChangePasswordPage from "../../pages/ca/CaChangePasswordPage";
import RequireCaAuth from "../ca/RequireCaAuth";
import { getRouterBasename } from "../../portals/portalConfig";

export default function CaRoutes() {
  const basename = getRouterBasename();

  return (
    <Router basename={basename === "/" ? undefined : basename}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<CaChangePasswordPage />} />
        <Route
          path="/form-25"
          element={
            <RequireCaAuth>
              <CaForm25Page />
            </RequireCaAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
